import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import routes from "../../../../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    Item,
    Toolbar,
    ColumnHeaderFilter,
    ColumnChooser,
    Selection,
    StateStoring
} from "devextreme-react/data-grid";
import { GridLayout } from "../../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';

function LocationsTab(props) {
    const allowedPageSizes = [10, 20, 100, 500, "all"];
    console.log(props.selectedRowData)
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const resultData = useMemo(() => {
        if (!props.itemRowId) {
            return null;
        }
        return  createStore({
            key: 'rLocation',
            loadParams:
            {
                itemId: function () {
                    return props?.itemRowId;
                },
                lotId: function () {
                    return props?.lotRowId;
                },
                sort: JSON.stringify([{ selector: "locationCode", desc: false }]) 
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Location.GetLocationsByItemAndLot}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        })
    }, [props.itemRowId,props.lotRowId]);

    return (
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            dataSource={resultData}
            showBorders={true}
            columnAutoWidth={true}
            allowColumnResizing={true}
            allowColumnReordering={true}
            remoteOperations={true}
            hoverStateEnabled={true}
            height="100%"
        >
            <Selection mode="single" />
            <ColumnHeaderFilter />
            <Sorting visible={true} mode="multiple" />
            <LoadPanel enabled={true} />
            <Paging defaultPageSize={10} />
            <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
                showNavigationButtons={true}
            />
            <FilterRow visible={true} />
            <Grouping autoExpandAll={false} />
            <Column dataField="warehouse" caption="WH" dataType="string" />
            <Column dataField="locationCode" caption="Location" dataType="string" />
            <Column dataField="onHand" caption="On-Hand" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
            <Column dataField="inReceiving" caption="In-Receving" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
            <Column dataField="outShipped" caption="In-Shipping" dataType="number"format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
            <Column dataField="outUnavailable" caption="Unavailable" dataType="number"format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
            <Column dataField="available" caption="Available" dataType="number"format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
            <Column dataField="inOrdered" caption="Pending Rec" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }}/>
            <Column dataField="outOrdered" caption="Pending Ship" dataType="number"format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
            <Column dataField="netAvailable" caption="Net Available" dataType="number"format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />

        </DataGrid>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(LocationsTab);